"use strict";
/*
 * Created on 01 15 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResult_1 = require("../ValidationResult");

var ValidationResultConverter_1 = require("./ValidationResultConverter");

var ValidationResultObjectConverter_1 = require("./ValidationResultObjectConverter");
/**
 * Implementation of {@link ValidationResultConverter}.
 *
 * @author JMe
 */


var ValidationResultConverterImpl =
/*#__PURE__*/
function (_ValidationResultConv) {
  _inherits(ValidationResultConverterImpl, _ValidationResultConv);

  /**
   * @param validationResultObjectConverter
   */
  function ValidationResultConverterImpl(validationResultObjectConverter) {
    var _this;

    _classCallCheck(this, ValidationResultConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ValidationResultConverterImpl).call(this));
    _this.validationResultObjectConverter = validationResultObjectConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ValidationResultConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this2 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        resultObjects: conversions.asObjectArray(source, 'resultObjects', function (obj) {
          return _this2.validationResultObjectConverter.toDocument(obj, conversions);
        })
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this3 = this;

      return new ValidationResult_1.ValidationResult(conversions.asObjectList(source, 'resultObjects', function (doc) {
        return _this3.validationResultObjectConverter.toObject(doc, conversions);
      }));
    }
  }]);

  return ValidationResultConverterImpl;
}(ValidationResultConverter_1.ValidationResultConverter);

ValidationResultConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ValidationResultObjectConverter_1.ValidationResultObjectConverter])], ValidationResultConverterImpl);
exports.ValidationResultConverterImpl = ValidationResultConverterImpl;